import { NgModule, ModuleWithProviders, Injectable,Injector } from '@angular/core';
import * as api from './service-proxies/service-proxies';
//只能用屬性注入，否則取得baseurl會比注入晚執行
@Injectable()
export class ApiService {
  //public get TokenAuth(): api.TokenAuthServiceProxy {
  //  return this.Injector.get(api.TokenAuthServiceProxy);
  //}

  public get Professor(): api.ProfessorServiceProxy {
    return this.Injector.get(api.ProfessorServiceProxy);
  }

  public get ProfessorCrud(): api.ProfessorCrudServiceProxy {
    return this.Injector.get(api.ProfessorCrudServiceProxy);
  }

  public get Code(): api.CodeServiceProxy {
    return this.Injector.get(api.CodeServiceProxy);
  }

  public get ProjectCrud(): api.ProjectCrudServiceProxy {
    return this.Injector.get(api.ProjectCrudServiceProxy);
  }

  public get Project(): api.ProjectServiceProxy {
    return this.Injector.get(api.ProjectServiceProxy);
  }

  public get PatentCrud(): api.PatentCrudServiceProxy {
    return this.Injector.get(api.PatentCrudServiceProxy);
  }

  public get Patent(): api.PatentServiceProxy {
    return this.Injector.get(api.PatentServiceProxy);
  }

  public get PaperCrud(): api.PaperCrudServiceProxy {
    return this.Injector.get(api.PaperCrudServiceProxy);
  }

  public get Paper(): api.PaperServiceProxy {
    return this.Injector.get(api.PaperServiceProxy);
  }

  public get ElasticSearch(): api.ElasticSearchServiceProxy {
    return this.Injector.get(api.ElasticSearchServiceProxy);
  }
  public get ContactLogCrud(): api.ContactLogCrudServiceProxy{
    return this.Injector.get(api.ContactLogCrudServiceProxy)
  }
  public get NewsCrud():api.NewsCrudServiceProxy{
    return this.Injector.get(api.NewsCrudServiceProxy)
  }
  public get News():api.NewsServiceProxy{
    return this.Injector.get(api.NewsServiceProxy)
  }

  constructor(
    private Injector: Injector
  ) {

  }
}
